import React,{useMemo} from 'react';
import { Modal,Button  } from 'antd';
import './productModal.less';
const QuestionModal = (props) => {
    //问题描述范例
    return useMemo(() => (
        <Modal
            centered
            footer={(
                <Button
                    onClick={() => props.onChangeModal()}
                    size="small"
                    type="primary"
                >&nbsp;知道了&nbsp;</Button>
            )}
            okText="知道了"
            onCancel={() => props.onChangeModal()}
            title="问题描述范例："
            visible={props.questionDemoVisible}
            width="460px"
            zIndex={2000}
        >
            <div className="question-demo-text-line">1.教材类：**页**知识点+我的疑问(举例：十年真题财管195页资本结构分析例题，怎么快速选择筹资方式)</div>
            <div className="question-demo-text-line">2.课程/讲义类：**老师**课/知识点/题目+我的疑问(举例：小周老师强化阶段讲义180页第5题不会做；韩老师精讲阶段审计基本原理中审计证据课视频中的内容不明白)</div>
            <div className="question-demo-text-line">3.题目类：截图上传+我的疑问(举例：图一，底5题选项D不明白)</div>
            {props.keyValue === 1 &&  <div className="question-demo-text-line">距离您正式上课{props.latestBookingTime}小时前，您可在预约详情页面修改问题描述。</div>}
        </Modal>
    ),[props.questionDemoVisible]);
};

export default QuestionModal;